export default "__VITE_ASSET__D6f7G9gP__"